import React from "react";
import classNames from "classnames";
import SVG from "react-inlinesvg";

import { toAbsoluteUrl } from "../../../../_helpers";

import "./style.scss";

export const CheckboxField = ({
  field,
  props,
  label,
  checkmarkClass,
  checkboxClassName,
  onChange,
  checked = null,
  disabled = false,
}) => {
  return (
    <>
      <label className={classNames(checkboxClassName, "checkbox")}>
        {checked === null ? (
          <input
            type="checkbox"
            {...field}
            {...props}
            onChange={onChange}
            disabled={disabled}
          />
        ) : (
          <input
            type="checkbox"
            {...field}
            {...props}
            onChange={onChange}
            checked={checked}
            disabled={disabled}
          />
        )}
        <span className={classNames("checkmark", checkmarkClass)}>
          <SVG
            src={toAbsoluteUrl("/media/svg/checkmark.svg")}
            className={classNames("checkpath")}
          />
          {}
        </span>
        {label}
      </label>
    </>
  );
};
